import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Avatar,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Container,
  IconButton,
} from "@mui/material";

import { StaffuseAuth } from "../../../security/StaffuseAuth";
import { Get_One_From_MongoDB } from "../../../api/Get_One_From_MongoDB";
import { Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort } from "../../../api/Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort";
import GetClientAddress from "../../../../functions/GetClientAddress";
import SearchSetRegisters from "../../../components/Search/SearchSetRegisters";
import { Get_Registers_GSPBookingEmails } from "../api/Get_Registers_GSPBookingEmails";
import { Get_Hubspot_Emails_By_Company_ID } from "../../Schools/api/Get_Hubspot_Emails_By_Company_ID";
import { Get_Hubspot_Company_By_ID } from "../../Schools/api/Get_Hubspot_Company_By_ID";
import { Get_Hubspot_Contacts_By_Company_ID } from "../../Schools/api/Get_Hubspot_Contacts_By_Company_ID";
import { Get_Hubspot_Contact_By_ID } from "./api/Get_Hubspot_Contact_By_ID";
import { Get_Hubspot_Contact_By_ID_Alert } from "./api/Get_Hubspot_Contact_By_ID_Alert";
import { Send_GSP_Booking_Email_To_School_Contact } from "./api/Send_GSP_Booking_Email_To_School_Contact";
import { Get_All_From_Array_Of_Object_IDs_From_MongoDB } from "../../../api/Get_All_From_Array_Of_Object_IDs_From_MongoDB";

const GSPBookingEmails = () => {
  const { logout } = StaffuseAuth();

  //----------------------------------------------------------
  //Get Bookings, non TCS, non Burs, non Arch, no note saying GSP email received
  const [Arr_Bookings, setArr_Bookings] = useState([]);
  useEffect(() => {
    Get_Registers_GSPBookingEmails(50, setArr_Bookings, logout);
  }, []);

  //--------------------------get all School--------------------
  //Find school upon chosen bookings changing
  const [AllSchools, setAllSchools] = useState([]);
  useEffect(() => {
    Get_All_From_Array_Of_Object_IDs_From_MongoDB(
      "Schools",
      "All_Schools",
      Arr_Bookings.map((obj_booking) => obj_booking.BasicInfo?.School_id),
      setAllSchools,
      logout
    );
  }, [Arr_Bookings]);
  console.log("AllSchools");
  console.log(AllSchools);

  //Pick a Booking to look at
  const [ChosenBooking, setChosenBooking] = useState({});
  function handleChooseBooking(e, obj_booking) {
    console.log("Chosen Booking: ", obj_booking);
    setHubspotCompany({});
    setHubspotContacts({ results: [] });
    setHubspotEmails({ results: [] });
    setChosenBooking(obj_booking);
  }
  //--------------------------School--------------------------------
  //Find school upon chosen bookings changing
  const [School, setSchool] = useState({});
  useEffect(() => {
    if (
      ChosenBooking.BasicInfo?.School_id &&
      ChosenBooking.BasicInfo?.School_id !== ""
    ) {
      Get_One_From_MongoDB(
        "Schools",
        "All_Schools",
        ChosenBooking.BasicInfo?.School_id,
        setSchool,
        logout
      );
    }
  }, [ChosenBooking]);

  //--------------------------HubSpot--------------------------------
  //Find HubSpot data upon chosen bookings changing

  //This is the state for the Hubspot Company
  const [HubspotCompany, setHubspotCompany] = useState({});
  //This is the state for the Hubspot Contacts
  const [HubspotContacts, setHubspotContacts] = useState({ results: [] });
  //This is the state for the Hubspot Emails
  const [HubspotEmails, setHubspotEmails] = useState({ results: [] });

  const HubspotContactsProps = [
    "firstname",
    "lastname",
    "email",
    "lastmodifieddate",
  ];

  useEffect(() => {
    if (School.HubspotCompanyID && School.HubspotCompanyID !== "") {
      Get_Hubspot_Company_By_ID(
        School.HubspotCompanyID,
        setHubspotCompany,
        logout
      );
    }
  }, [School]);
  useEffect(() => {
    if (School.HubspotCompanyID && School.HubspotCompanyID !== "") {
      Get_Hubspot_Contacts_By_Company_ID(
        School.HubspotCompanyID,
        setHubspotContacts,
        logout
      );
    }
  }, [School]);
  useEffect(() => {
    if (School.HubspotCompanyID && School.HubspotCompanyID !== "") {
      Get_Hubspot_Emails_By_Company_ID(
        School.HubspotCompanyID,
        setHubspotEmails,
        logout
      );
    }
  }, [School]);

  const HubspotEmailsProps = [
    "hs_createdate",
    "hs_email_subject",
    "hs_email_from_email",
    "hs_email_to_email",
  ];

  function countEmails(Email) {
    let count = 0;
    if (!Email || Email === "" || Email === null || Email === undefined) {
      return count;
    }
    if (Array.isArray(HubspotEmails)) {
      return count;
    } else {
      HubspotEmails.results.forEach((obj_email) => {
        let info = obj_email.properties;
        for (let key in info) {
          if (
            Email &&
            info[key] &&
            info[key].toLowerCase() === Email.toLowerCase()
          ) {
            count++;
          }
        }
      });
      return count;
    }
  }

  let HubspotContacts_Sorted =
    HubspotContacts.results && HubspotContacts.results.length > 0
      ? HubspotContacts.results.sort((a, b) => {
          if (
            countEmails(a.properties?.email) > countEmails(b.properties?.email)
            //a.properties.firstname < b.properties.firstname
          ) {
            return -1;
          }
          if (
            countEmails(a.properties?.email) < countEmails(b.properties?.email)
            //a.properties.firstname > b.properties.firstname
          ) {
            return 1;
          }
          return 0;
        })
      : [];

  //---------------------------------Search one Contact

  function handleSearchContact(e, Contact) {
    e.preventDefault();
    Get_Hubspot_Contact_By_ID_Alert(Contact.id);
  }

  //---------------------find most spoem to staff

  function functionMostSpokenTo(Email) {
    let count = 0;
    if (!Email || Email === "" || Email === null || Email === undefined) {
      return "";
    }
    let maxCount = 0;
    let mostSpokenToEmail = "";

    if (HubspotEmails.results && HubspotEmails.results.length > 0) {
      const emailCounts = {};

      HubspotEmails.results.forEach((obj_email) => {
        const emailFrom = obj_email.properties?.hs_email_from_email || "";
        const emailTo = obj_email.properties?.hs_email_to_email || "";

        if (emailFrom === Email || emailTo === Email) {
          if (emailFrom.includes("@investin.org")) {
            emailCounts[emailFrom] = (emailCounts[emailFrom] || 0) + 1;
          }

          if (emailTo.includes("@investin.org")) {
            emailCounts[emailTo] = (emailCounts[emailTo] || 0) + 1;
          }
        }
      });

      for (const email in emailCounts) {
        if (emailCounts[email] > maxCount) {
          maxCount = emailCounts[email];
          mostSpokenToEmail = email;
        }
      }
    }

    return mostSpokenToEmail;
  }

  //---------------------Send
  function handleSend(e, Contact) {
    e.preventDefault();
    e.target.disabled = true;
    e.target.innerText = "Sent";
    e.target.style.backgroundColor = "#85c1e9";
    e.target.style.color = "white";
    console.log(ChosenBooking);
    console.log(Contact);
    Send_GSP_Booking_Email_To_School_Contact(Contact, ChosenBooking, logout);
  }
  return (
    <div style={{ marginLeft: "10px", marginRight: "10px" }}>
      <style jsx>{`
        #BookingTable {
          font-family: Arial, Helvetica, sans-serif;
          border-collapse: collapse;
          width: 100%;
        }

        #BookingTable td,
        #BookingTable th {
          border: 1px solid #ddd;
          padding: 8px;
        }

        #BookingTable tr:nth-child(even) {
          background-color: #ffffff;
        }

        #BookingTable tr:hover {
          background-color: #ddd;
        }

        #BookingTable th {
          padding-top: 12px;
          padding-bottom: 12px;
          background-color: #04aa6d;
          color: white;
        }
      `}</style>

      {/* <!-- Bookings --> */}
      <div
        className="w3-row-padding w3-padding-64 w3-theme-l5 w3-center"
        id="Bookings"
        style={{ position: "relative", minHeight: "100vh" }}
      >
        <br></br>
        <div style={{ width: "100%", display: "flex" }}>
          <SearchSetRegisters setRegisters={setArr_Bookings} />
        </div>
        <h1>GSP Emails</h1>
        <div
          style={{
            overflowX: "scroll",
            overflowY: "auto",
            maxHeight: "calc(100vh - 400px)",
          }}
        >
          <table id="BookingTable">
            <thead>
              <tr>
                <th>Date</th>
                <th>Name</th>
                <th>Programme Title</th>
                <th>Programme Date</th>
                <th>Programme Varient</th>
                <th>Booking Status</th>
                <th>School Name</th>
                <th>GSP Assigned</th>
                <th>Choose</th>
              </tr>
            </thead>
            <tbody>
              {Arr_Bookings.map((obj_booking, index) => (
                <>
                  <tr key={index}>
                    {" "}
                    <td>{obj_booking.BasicInfo?.Created_At || ""}</td>
                    <td>
                      {obj_booking.BasicInfo?.First_Name || ""}{" "}
                      {obj_booking.BasicInfo?.Last_Name || ""}
                    </td>
                    <td>{obj_booking.BasicInfo?.ProgrammeTitle || ""}</td>
                    <td>{obj_booking.BasicInfo?.ProgrammeDate || ""}</td>
                    <td>{obj_booking.BasicInfo?.ProgrammeVarient || ""}</td>
                    {obj_booking.MetaData?.Archived === "Yes" ? (
                      <td style={{ backgroundColor: "#f1948a" }}>Removed</td>
                    ) : obj_booking.MetaData?.Reserved === "Yes" ? (
                      <td style={{ backgroundColor: "#85c1e9" }}>Reserved</td>
                    ) : (
                      <td style={{ backgroundColor: "#DAF7A6" }}>Confirmed</td>
                    )}
                    <td>
                      {AllSchools.find((school) => {
                        return school._id === obj_booking.BasicInfo?.School_id;
                      })?.School_Name || ""}
                    </td>
                    <td>
                      {AllSchools.find((school) => {
                        return school._id === obj_booking.BasicInfo?.School_id;
                      })?.School_PD || ""}
                    </td>
                    <td>
                      {obj_booking.MetaData?.TCS === "Yes" ||
                      obj_booking.MetaData?.Archived === "Yes" ||
                      obj_booking.MetaData?.Bursary === "Yes" ||
                      !obj_booking.BasicInfo?.School_id ||
                      obj_booking.BasicInfo?.School_id === "" ? (
                        "Not Eligible"
                      ) : (
                        <button
                          onClick={(e) => handleChooseBooking(e, obj_booking)}
                        >
                          Choose
                        </button>
                      )}
                    </td>
                  </tr>
                </>
              ))}
            </tbody>
          </table>
        </div>
        <h1>Booking</h1>
        <h3>{ChosenBooking._id || ""}</h3>
        <h1>School</h1>
        <h3>
          {School.School_Name}, {School.School_Country},{" "}
          {School.School_PostCode}, {School.School_PD}
        </h3>
        <h1>Hubspot Company</h1>
        <h3>
          Address: {HubspotCompany.properties?.country},{" "}
          {HubspotCompany.properties?.state}, {HubspotCompany.properties?.city},{" "}
          {HubspotCompany.properties?.address}, {HubspotCompany.properties?.zip}
          <br></br>
          Contatcs: {HubspotCompany.properties?.num_associated_contacts}
        </h3>

        <h1>HubSpot Contacts</h1>
        <div
          style={{
            overflowX: "scroll",
            overflowY: "auto",
            maxHeight: "calc(100vh - 400px)",
          }}
        >
          <table id="BookingTable">
            <thead>
              <tr>
                <th>index</th>
                {HubspotContactsProps.map((prop, index) => (
                  <th key={index}>{prop}</th>
                ))}
                <th>Activity</th>
                <th>Most Spoken To</th>
                <th>Check HubSpot Job</th>
                <th>Send</th>
              </tr>
            </thead>
            <tbody>
              {HubspotContacts_Sorted.map((HubspotContact, index) => (
                <>
                  <tr key={index}>
                    <td>{index}</td>
                    {HubspotContactsProps.map((prop) => (
                      <td>
                        {HubspotContact.properties[prop]
                          ? HubspotContact.properties[prop]
                          : ""}
                      </td>
                    ))}
                    <td>{countEmails(HubspotContact.properties?.email)}</td>
                    <td>
                      {functionMostSpokenTo(HubspotContact.properties?.email)}
                    </td>
                    <td>
                      <button
                        onClick={(e) => handleSearchContact(e, HubspotContact)}
                      >
                        Check Job
                      </button>
                    </td>
                    <td>
                      {HubspotContact.properties?.email ? (
                        <button onClick={(e) => handleSend(e, HubspotContact)}>
                          Send Email
                        </button>
                      ) : (
                        ""
                      )}
                    </td>
                  </tr>
                </>
              ))}
            </tbody>
          </table>
        </div>

        <h3>Hubspot Engagements</h3>
        <div
          style={{
            overflowX: "scroll",
            overflowY: "auto",
            maxHeight: "calc(100vh - 400px)",
          }}
        >
          <table id="BookingTable">
            <thead>
              <tr>
                {HubspotEmailsProps.map((prop, index) => (
                  <th key={index}>{prop}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {HubspotEmails.results.map((HubspotEmail, index) => (
                <>
                  <tr key={index}>
                    {HubspotEmailsProps.map((prop) => (
                      <td>
                        {HubspotEmail.properties[prop]
                          ? HubspotEmail.properties[prop]
                          : ""}
                      </td>
                    ))}
                  </tr>
                </>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default GSPBookingEmails;
